import { ApproverGetResponse } from '../types/getApproverResponse';
import axiosInstance from "./axiosInstance";

export const getAdminApi = async (): Promise<ApproverGetResponse> => {
  try {
    const response = await axiosInstance.get('/api/admin/getadmin');
    return response.data; // The response will be typed as `ApproverListResponse`
  } catch (error) {
    console.error('Error fetching approver list:', error);
    throw error;
  }
};

export const getPlantsApi = async (): Promise<string[]> => {
  try {
    const response = await axiosInstance.get('/api/admin/get-plants');
    return response.data; // The response will be typed as `string[]`
  } catch (error) {
    console.error('Error fetching plants list:', error);
    throw error;
  }
};

export const getMaterialTypeApi = async (): Promise<string[]> => {
  try {
    const response = await axiosInstance.get('/api/admin/get-ingredients');
    return response.data; // The response will be typed as `string[]`
  } catch (error) {
    console.error('Error fetching material types list:', error);
    throw error;
  }
};
